import { Component } from '@angular/core';

@Component({
  selector: 'app-megapay-loader',
  template: `
    <div class="flex items-center justify-center">
      <div class="relative w-24 h-24">
        <!-- Back card with animation -->
        <div class="absolute inset-0 animate-pulse-slow">
          <svg viewBox="0 0 100 100" class="w-full h-full">
            <rect x="10" y="15" width="70" height="55" rx="12" 
                  fill="none" stroke="#FF8C00" stroke-width="6"
                  class="animate-draw-back"/>
            <line x1="20" y1="25" x2="60" y2="25" 
                  stroke="#FF8C00" stroke-width="5" stroke-linecap="round"
                  class="animate-draw-line"/>
          </svg>
        </div>
        
        <!-- Front card with animation -->
        <div class="absolute inset-0 animate-pulse-slow" style="animation-delay: 0.2s">
          <svg viewBox="0 0 100 100" class="w-full h-full">
            <rect x="20" y="30" width="70" height="55" rx="12" 
                  fill="white" stroke="#FF8C00" stroke-width="6"
                  class="animate-draw-front"/>
            
            <!-- Animated 'm' letter with Momo Trust Display style -->
            <text x="55" y="68" 
                  font-family="'Momo Trust Display', 'Arial Rounded MT Bold', 'Nunito', sans-serif" 
                  font-size="38" 
                  font-weight="700"
                  fill="#5B3A9E" 
                  text-anchor="middle"
                  class="animate-fade-m">m</text>
          </svg>
        </div>
        
        <!-- Rotating glow effect -->
        <div class="absolute inset-0 animate-spin-slow opacity-30">
          <div class="w-full h-full rounded-full bg-gradient-to-r from-transparent via-orange-400 to-transparent blur-sm"></div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./megapay-loader.component.scss'],
  standalone: true
})
export class MegapayLoaderComponent {}
